import packageInfo from '../../package.json';

export const environment = {
  production: true,
  apiUrl: '',
  apiAteosUrl: '',
  gumUrl: '',
  version: packageInfo.version,
};
